module.exports = __webpack_public_path__ + "static/media/cardEight.f82b1072.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowThree/cardEight.jpg
// module id = 64
// module chunks = 0